import {createSelector} from 'reselect';
import get from 'lodash/get';

const teamSelector = state => state.team;

export const getTeams = createSelector(
  [teamSelector],
  teams => get(teams, 'teams', {})
);
